import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "border-l-4 border-yellow-500 bg-yellow-50 px-4 py-2 text-sm leading-6 text-gray-600" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("p", _hoisted_1, [
    _createTextVNode(_toDisplayString(_ctx.originator.Name.split(' ')[0]) + " has sent us ", 1),
    _createElementVNode("b", null, _toDisplayString(_ctx.softQuotes?.length || 0) + " quotes", 1),
    _createTextVNode(" in the last 12 months with an average loan size of "),
    _createElementVNode("b", null, _toDisplayString(_ctx.loanAmount), 1),
    _createTextVNode(" and an average "),
    _createElementVNode("b", null, _toDisplayString(_ctx.LTV) + "% LTV", 1),
    _createTextVNode(". ")
  ]))
}